export const getMergedStyles = (defaultClassName, inlineStyle = {}, styleOverride) => {
    let mergedClassName = defaultClassName;
    let mergedStyle = { ...inlineStyle };
  
    if (styleOverride) {
      if (typeof styleOverride === "string") {
        mergedClassName = `${defaultClassName} ${styleOverride}`;
      } else if (typeof styleOverride === "object") {
        mergedStyle = { ...mergedStyle, ...styleOverride };
      }
    }
  
    return [mergedClassName, mergedStyle];
  };